module.exports = __webpack_public_path__ + "980be7bb.svg";